module.exports = __webpack_public_path__ + "img/DE00746.708f6622.png";